import LookUpModel from "./LookUpModel";

export default class LookupManagementModel extends LookUpModel {
    public readonly idAdmCategory: number = 0;

    constructor(data: Partial<LookupManagementModel>) {
        super(data);

        this.update(data);
    }
}
